import React from 'react';
import './MissionSection.css';
import FocusAreas from '../../assets/Focus.png';

const MissionSection = () => {
  return (
    <section className="focus-mission-section">
      <div className="focus-mission-container">
        <div className="mission-image">
          <img src={FocusAreas} alt="Our Mission" />
        </div>
        <div className="mission-content">
          <h2>Our Mission</h2>
          <p>
          Our mission is to bridge the quantum gap by driving innovation, empowering talent, and supporting startups across Kenya and beyond. Whether you're an experienced professional or just starting your quantum journey, Quantumke offers a collaborative space to learn, connect, and contribute to a transformative future.
          </p>
        </div>
      </div>
    </section>
  );
};

export default MissionSection;
